// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2XWxA","title":"Header_title__xADmW","left":"Header_left__1tz0_","clinicName":"Header_clinicName__2jDuX"};